import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapStylesFactory } from '../../shared/PropertyMapEpic/map.styles';
import EpicHeaderBannerText from '../../RifoDesign/EpicHeaderBannerText/epic.header.banner.text.vue';
import EpicStandardLayout from '../../layout/EpicStandard/epic.standard.layout.vue';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../../../src/utils/axios.promise';
const GmapCluster = require('vue2-google-maps/dist/components/cluster').default;
@Component({
    components: {
        EpicHeaderBannerText,
        GmapCluster,
        'layout': EpicStandardLayout
    }
})
export default class EpicContactUsPage extends Vue {
    public warningInfo: string = '';
    public configs = new CommonConfig();
    public center = { lat: 43.8144500, lng: -79.3504678 };
    public name: string = '';
    public email: string = '';
    public message: string = '';
    public disabledBtn: Boolean = false;
    public options = {
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
        styles: mapStylesFactory({
            showBussiness: true
        }),
    };
    public mobileBannerUri = `${this.configs.rifoDesignAssetsUrl}/epic-header/bg7.jpg`;

    public created() {
    }
    public async beforeSubmit(e: Event) {
        e.preventDefault();
        if (this.email === '') {
            this.warningInfo = 'Email Is Required';
            return;
        }
        if (this.email !== ''
        &&  /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/.test(this.email)) {
            const apiHost = this.configs.mnsService;
            const messageCombine = `<h4>Message from Rifo Epic Web:</h4>
                <p style="display:${this.name ? 'block' : 'none'}; font-weight:normal;"><b>name:</b> ${this.name}</p>
                <p style="display:${this.email ? 'block' : 'none'}; font-weight:normal;"><b>email:</b> ${this.email}</p>
                <p style="display:${this.message ? 'block' : 'none'}; font-weight:normal;"><b>message:</b> ${this.message}</p>`;
            const enTrustBody = {
                'message': [
                    {
                        'msg': {
                            'MessageTag': 'tag-send-email',
                            'Message': {
                                'demotest': 'test',
                                'dataset': {
                                    'to': 'info@realjaja.com',
                                    'from': this.email,
                                    'subject': 'Inquiry From Rifo Epic Website',
                                    'html': messageCombine
                                }
                            }
                        },
                        'delaysec': 10
                    }],
                'queuename': this.configs.mnsQueueName
            };
             const result = await AxiosPromise.postJson(`${apiHost}/mnsao/messagequeue/batchsend`, enTrustBody);
             if (result && result.status === 200) {
                // this.disabledBtn = true;
                this.$Notice.success({
                    title: 'Message Sent',
                    desc: 'Thank you!'
                 });
                 this.email = '';
                 this.name = '';
                 this.message = '';
             }
        }
        return false;
    }
    public validateEmail() {
        if (this.email === '') {
            this.warningInfo = 'Email Is Required';
            return;
        }
        if (!/^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/.test(this.email)) {
            this.warningInfo = 'Email Format Is Incorrect';
            return;
        }
        this.warningInfo = '';

    }
}
